import { api } from '@cma/app'
import {
  DestroyContactItemMutation,
  DestroyContactItemMutationVariables
} from '@cma/generated/graphql'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { gql } from 'graphql-request'

export function useDestroyContactItem() {
  const queryClient = useQueryClient()
  return useMutation<
    DestroyContactItemMutation,
    Error,
    DestroyContactItemMutationVariables
  >(
    ({ id }) => {
      const query = gql`
        mutation DestroyContactItem($id: ID!) {
          destroyContactItem(id: $id) {
            contactItem {
              id
            }
            errors
          }
        }
      `
      const variables = { id }
      return api<DestroyContactItemMutation>({ query, variables })
    },
    {
      async onSuccess() {
        await queryClient.invalidateQueries(['contactItems'])
      }
    }
  )
}
